import * as React from 'react';
import { clsx } from 'clsx';
import { TSPTheme } from '../../types/specialProjects/themes';
import * as styles from './SPThemeWrapper.css';

interface ICallbackButtonWrapperProps {
  children: React.ReactElement<any> | number | string;
  theme?: TSPTheme;
}

/**
 * Special Projects Button Wrapper
 * Обертка для переопределения стилей элементов ui-kit для спец проектов
 */
export function SPThemeWrapper({ children, theme }: ICallbackButtonWrapperProps) {
  return (
    <div
      className={clsx(
        styles['theme'],
        { [styles['fsk_fill_primary']]: theme === 'fsk_fill_primary' },
        { [styles['fsk_fill_secondary']]: theme === 'fsk_fill_secondary' },
        { [styles['fsk_fill_white_primary']]: theme === 'fsk_fill_white_primary' },
        { [styles['fsk_stroke_primary']]: theme === 'fsk_stroke_primary' },
      )}
    >
      {children}
    </div>
  );
}
